const moment = require('moment')

export default function combineDateTime (origDate, timeHours, timeMinutes) {
  const date = moment(origDate).format('DD/MM/YYYY')
  const time = timeHours + ':' + timeMinutes
  const dateTime = moment(date + ' ' + time, 'DD/MM/YYYY HH:mm')
  return dateTime.toDate()
}
